import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { ProgrammingLanguageListComponent } from './programming-language-list/programming-language-list.component'

export const programmingLanguageRoutes: Route[] = [
  {
    path: 'programming-languages',
    component: ProgrammingLanguageListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'programming-languages/:id/edit',
    redirectTo: 'programming-languages/:id',
    pathMatch: 'full'
  },
  {
    path: 'programming-languages/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'ProgrammingLanguage',
        nameSingular: 'Programming Language',
        namePlural: 'Programming Languages',
        path: 'programming-languages',
        slug: 'taxonomies/programming-languages',
        title: 'Programming Languages'
      }),
      permission: 'readTaxonomies'
    }
  }
]
